export const environment = {
  production: false,
  apiBaseUrl: "http://localhost:3000/geoweb-api/",
  appTitle: "GEOL",
  authUrl: "http://localhost:3000/auth/",
  mapBoxToken: "pk.eyJ1Ijoic2luYXBzeXMiLCJhIjoiY2wzdm80ZW9mMHQ0cTNkbnAzeGFpbXZ0aCJ9.XyNZblzOwhUdy6MpF1lNlA",
  markersBaseUrl: "http://localhost:3000/geoweb-api/markers/",
  adminUrl: "I5JdqU2Hq4pVC1k0BD1qPkyZOyMl9QHpAwfgc2Y3W4EzgVwtmj",
  mostraAssa: true,
};
